import { BorderExample } from 'components/designSystem/utilityClasses/BorderExample';
import { UtilityClass } from 'components/designSystem/utilityClasses/UtilityClass';
import { UtilityClassSectionHeader } from 'components/designSystem/utilityClasses/UtilityClassSectionHeader';
import { Section } from 'components/shared/Section';

const borders = [
    <UtilityClassSectionHeader key="1" />,
    <div key="2">
        <UtilityClass
            className=".border__radius--badge"
            example={<BorderExample className="border__radius--badge" width={200} />}
        />
        <UtilityClass
            className=".border__radius--card"
            example={<BorderExample className="border__radius--card" width={200} />}
        />
        <UtilityClass
            className=".border__radius--circle"
            example={<BorderExample className="border__radius--circle" width={20} />}
        />
        <UtilityClass
            className=".border__radius--rounded"
            example={<BorderExample className="border__radius--rounded" width={200} />}
        />
        <UtilityClass
            className=".border__radius--none"
            example={<BorderExample className="border__radius--none" width={200} />}
        />
    </div>,
];

export const Borders = () => <Section title="Border Utility Classes" contentArray={borders} />;
